import React from 'react';
import { StarIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { whyChooseUs } from '../../data/features';
import { images } from '../../data/images';
import { container } from '../../utils/styles';
import { SectionHeading } from '../shared/SectionHeading';
export function WhyChooseUs() {
  const {
    t
  } = useLanguage();
  return <section className="bg-white py-20 sm:py-24" aria-labelledby="why-heading" data-id="element-82" data-mp="32x893wh51xrz">
      <div className={`${container} grid gap-12 lg:grid-cols-12 lg:gap-16`} data-id="element-83" data-mp="32zcmd50xg94x">
        <div className="relative lg:col-span-5" data-id="element-84" data-mp="36ybqineu41vb">
          <img src={images.home.src} alt={t(images.home.alt)} loading="lazy" className="h-80 w-full rounded-2xl object-cover sm:h-[28rem] lg:sticky lg:top-36 lg:h-[36rem]" data-id="element-85" data-mp="2t7onwk5ydrty" />
          <div className="absolute bottom-5 left-5 right-5 flex items-center gap-4 rounded-xl bg-white p-4 shadow-lg sm:right-auto lg:bottom-8" data-id="element-86" data-mp="3lv2nyr4y73ia">
            <span className="font-display text-3xl font-bold text-ink" data-id="element-87" data-mp="3qoni283f7dc7">5.0</span>
            <div data-id="element-88" data-mp="1vbt21vm33dhl">
              <div className="flex gap-0.5" aria-hidden="true" data-id="element-89" data-mp="1v96tptrdctyb">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" data-id="element-90" data-mp="251w6qt2kifvr" data-mpi={i} />)}
              </div>
              <p className="text-sm text-ink-soft" data-id="element-91" data-mp="209l5nmw3co1m">
                {t({
                en: 'Rated by families on Google',
                es: 'Calificado por familias en Google'
              })}
              </p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7" data-id="element-92" data-mp="29znwbgfqppws">
          <SectionHeading id="why-heading" title={t({
          en: 'Why Families Choose A.M. Home Care',
          es: 'Por Qué las Familias Eligen A.M. Home Care'
        })} intro={t({
          en: 'Care that feels like family, with the training and reliability of a professional agency.',
          es: 'Un cuidado que se siente como familia, con la capacitación y confiabilidad de una agencia profesional.'
        })} data-id="element-93" data-mp="2a2san6mx6216" />
          <ul className="mt-10 divide-y divide-mist border-t border-mist" data-id="element-94" data-mp="2oqnkuojkab9x">
            {whyChooseUs.map(item => {
            const Icon = item.icon;
            return <li key={item.id} className="flex gap-5 py-6" data-id="element-95" data-mp="2ymgx06tdc2r6">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-sage-tint text-sage-dark" aria-hidden="true" data-id="element-96" data-mp="32p58km9gvnru">
                    <Icon className="h-6 w-6" data-id="element-97" data-mp="37nf44xz3sqdz" />
                  </span>
                  <div data-id="element-98" data-mp="3cmrrrkxsu1hm">
                    <h3 className="text-xl font-bold text-ink" data-id="element-99" data-mp="3cm03kv6j761d">{t(item.title)}</h3>
                    <p className="mt-1.5 leading-relaxed text-ink-soft" data-id="element-100" data-mp="3hdrnwnz3gfj2">{t(item.body)}</p>
                  </div>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}